module.exports = __webpack_public_path__ + "img/180.172e1584.png";